import { render, staticRenderFns } from "./description_template.vue?vue&type=template&id=5336862d&"
import script from "./description_template.vue?vue&type=script&lang=js&"
export * from "./description_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports